// extracted by mini-css-extract-plugin
module.exports = {"subdescription":"PagePresentation_subdescription__MFJ3z","frameText":"PagePresentation_frameText__dQq9l","link":"PagePresentation_link__Ffh9x"};